import { render, staticRenderFns } from "./PopupEditGalleryImage.vue?vue&type=template&id=da13dd52&scoped=true&"
import script from "./PopupEditGalleryImage.vue?vue&type=script&lang=js&"
export * from "./PopupEditGalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditGalleryImage.vue?vue&type=style&index=0&id=da13dd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da13dd52",
  null
  
)

export default component.exports